import type { FC } from "react";
import { createElement } from "react";

export interface FileRef {
  fileId: string;
  name: string | null;
  type: string | null;
  size: number | null;
}

export interface FileAttachment {
  key: string;
  fileId: string | null;
  name: string;
  type: string;
  size: number | null;
  previewUrl: string | null;
  status: "uploading" | "done" | "error";
}

export function fileSizeString(bytes?: number): string {
  if (bytes === undefined) {
    return "";
  }
  const units = ["B", "KB", "MB", "GB", "TB"];
  let b = bytes;
  let i = 0;
  while (b >= 1024) {
    b /= 1024;
    i++;
  }
  return `${b.toFixed(2)} ${units[i]}`;
}

export const DocumentIcon: FC = () =>
  createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    createElement("path", {
      d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
    }),
    createElement("polyline", { points: "14 2 14 8 20 8" })
  );
